const LOCALE_TAGS: Record<string, string> = {
  DE: "de-DE",
  EN: "en-US",
  JA: "ja-JP",
}

export function localeTagFor(language: string): string {
  return LOCALE_TAGS[language.toUpperCase()] ?? "en-US"
}
